import { useTranslation } from "react-i18next";
import { useApplicationParameters } from "src/api/client-api/appParams";

export const useActionPlanOptions = () => {
    const { t } = useTranslation();
    const { applicationParameters, isActionPlanSimplified } = useApplicationParameters();
    const isSimplified = isActionPlanSimplified();

    const withoutPlanName =
        isSimplified ?
            t("action_plan.withoutactions")
        :   (applicationParameters?.["actionPlan-scenario-without"] ?? t("action_plan.withoutactions"));

    const withPlanName = applicationParameters?.["actionPlan-scenario-with"] ?? t("action_plan.withactions");

    const persistedOptions = {
        withoutPlanName,
        withPlanName,
        comparedToWithoutPlan: `${t("score_reference.in_relation")} ${withPlanName}`,
    } as const;

    return persistedOptions;
};
